import { AppBar, CircularProgress, IconButton, Toolbar, Typography, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router';
import TimeAgo from './TimeAgo';
import { OrderReviewContext } from './OrderReviewContext';
import classnames from 'classnames';
import { ORDER_DETAIL_TAB_KEY, tabKeys } from '../Orders/OrderDetail';
import { da } from 'date-fns/locale';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { processPhotos } from '../../services';
import { AppContext } from '../../AppContext';
import cn from 'classnames';



const drawerWidth = 325;

const propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  setDrawerOpen: PropTypes.func.isRequired,
  order: PropTypes.object,
  sideViewForm: PropTypes.bool,
  setSideViewForm: PropTypes.func,
  setHideAllPhotos: PropTypes.func,
  hideAllPhotos: PropTypes.bool,
  isAllPhotosTab: PropTypes.bool,
};

const SENT_TO_CLIENT_STATUS_IDS = [9, 10, 33];

function Navbar({
  classes,
  history,
  drawerOpen,
  setDrawerOpen,
  clientId,
  returnToGrid,
  order,
  sideViewForm,
  setSideViewForm,
  hideAllPhotos,
  setHideAllPhotos,
  isAllPhotosTab,
  taggedPhotos,
  setTaggedPhotos,
}) {
  const onClickMenuButton = () => {
    setDrawerOpen(true);
    localStorage.setItem('drawerOpen', true);
  };
  const { state } = useContext(OrderReviewContext);
  var pastDue = false;
  var daysPastDue = 0;
  var currentDate = new Date();
  if (Date.parse(state.order.dueDate) < currentDate) {
    pastDue = true;
    daysPastDue = Math.floor((new Date() - Date.parse(state.order.dueDate)) / (1000 * 3600 * 24)) + 1;
  } else {
    daysPastDue = Math.floor((Date.parse(state.order.dueDate) - new Date()) / (1000 * 3600 * 24)) + 1;
  }

  // #region HOOKS
  const { dispatch } = useContext(AppContext);

  // #endregion

  const orderLineId = state.orderLineId;


  const processPhotosImmediatley = async orderLineId => {
    console.log('processing photos for orderLineId: ' + orderLineId);
    try {
      let result = await processPhotos(orderLineId);

      if (result?.success) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: result.message || 'Photos processed successfully!',
          },
        });
      } else if (result?.message) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: result.message,
          },
        });
      } else {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: 'Could Not Process Photos',
          },
        });
      }
    } catch (err) {
      console.log('Could not process photos: ' + err);

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: err?.message || 'Could Not Process Photos',
        },
      });
    }
  };


  const goToCommunicationLog = () => {
    localStorage.setItem(ORDER_DETAIL_TAB_KEY, tabKeys.communication);
    history.push(`/orders/${state.orderLineId}?referrer=${state.isFieldRep ? 'Order Review' : 'QA Review'}`);
  };

  return (
    <div className={classnames('flex-1', 'row-between-center', classes.headerContainer)}>
      <Typography variant="subtitle1" className={classes.orderTicketNumber} noWrap style={{ textAlign: 'left' }}>
        <div className={classes.returnToGridLink} onClick={returnToGrid}>
          {'<'} Return to Orders Grid
        </div>
        <div className={classes.orderNumberLabel}>
          Order <span style={{ color: 'var(--jmi-blue)' }}>#{state.orderLineId}</span>
        </div>
        <div className={classes.pastDueLabel}>
          <span style={pastDue ? { color: 'red' } : { color: 'var(--jmi-blue)' }}>
            {pastDue ? ' (' + daysPastDue + ' Days Past Due)' : '(' + daysPastDue + ' Days Till Due)'}
          </span>
        </div>
      </Typography>
      <img
        src={`https://jmistorage.blob.core.windows.net/clientid-${clientId}/logo.jpg`}
        className={classes.clientLogo}
      />
      <Typography variant="subtitle1" className={classes.orderTicketNumber} noWrap style={{ textAlign: 'left' }}>
        <Button
          variant="contained"
          onClick={goToCommunicationLog}
          className={classNames('light-blue-background')}
          style={{ marginLeft: 15 }}
        >
          Communication Log
        </Button>
      </Typography>
      <FormControlLabel
        control={<Switch checked={sideViewForm} onChange={() => setSideViewForm(!sideViewForm)} />}
        label="Toggle Side Form"
        style={{ paddingLeft: '15px' }}
      />
      {isAllPhotosTab && (
        <>
          <FormControlLabel
            control={<Switch checked={taggedPhotos} onChange={() => setTaggedPhotos(!taggedPhotos)} />}
            label="Untagged Photos"
            style={{ paddingLeft: '15px' }}
          />
          <FormControlLabel
            style={{ paddingLeft: '15px' }}
            control={
              <Button
                aria-label="Toggle Image Visibility"
                className={classes.button}
                onClick={() => setHideAllPhotos(!hideAllPhotos)}
              >
                Hidden Photos
                {!hideAllPhotos ? (
                  <VisibilityIcon className={classes.rightIcon} style={{ paddingLeft: '10px' }} />
                ) : (
                  <VisibilityOffIcon className={classes.rightIcon} style={{ paddingLeft: '10px' }} />
                )}
              </Button>
            }
          />
        </>
      )}
      {!!order && SENT_TO_CLIENT_STATUS_IDS.includes(order.orderLineStatusLookupId) && (
        <Typography variant="subtitle1" className={classNames('dark-blue-text', 'p-15')} noWrap>
          SENT TO CLIENT
        </Typography>
      )}

      <div className={classes.toolbarAttributeWrapper} />
      <Typography variant="subtitle1" className={classes.toolbarAutoSave}>
        {state.isAutoSaving || state.isEditing ? 'Saving...' : 'Saved.'}
      </Typography>
    </div>
  );
}

const styles = theme => ({
  headerContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  returnToGridLink: {
    textDecoration: 'underline',
    color: '#6FBE48',
    fontSize: 12,
    cursor: 'pointer',
    marginBottom: 5,
  },
  pastDueLabel: {
    fontSize: 14,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  orderNumberLabel: {
    fontSize: 18,
    color: 'var(--jmi-blue)',
    fontWeight: 'bold',
  },
  toolbarAttributeWrapper: {
    flexGrow: 1,
  },
  toolbarAutoSave: {
    color: 'var(--jmi-blue)',
  },
  toolbar: {
    boxShadow: 'none',
  },
  appBar: { padding: '0', background: '#315382' },
  menuButton: {
    // color: "#fff",
    marginRight: '24px',
  },
  orderTicketNumber: {
    lineHeight: 'normal',
    margin: '0.25rem 0',
  },
  drawerOpen: {
    left: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
  },
  tooltip: {
    fontSize: '0.8rem',
  },
  clientLogo: {
    height: '75%',
    marginLeft: 20,
    maxWidth: 200,
    maxHeight: 50,
  },
  circularProgress: {
    color: 'var(--jmi-blue)',
  },
});

Navbar.propTypes = propTypes;

export default withStyles(styles)(withRouter(Navbar));
